module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/cx-dda4107fd05b8081ae62bc9871ba1d9d.svg";